import { baseURL } from "../../ApiSettings";
import axios from 'axios';

class Service {

    async GetActiveAccounting(params) {
        return await axios.get(`${baseURL}/Accounting/Active`, { params } )
        .then(res => {
            return res;
        })
        .catch(err => {
            console.log('Get Active Accounting Error', err);
            return false
        });
    }

    async GetPaymentInfo(params, token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return await axios.get(`${baseURL}/Accounting/payment/info`, { params } )
        .then(res => {
            return res;
        })
        .catch(err => {
            console.log('Get Payment Info Error', err);
            return false
        });
    }

}
const MobilePayment = new Service();
export default MobilePayment;
